import {createFileRoute, redirect} from "@tanstack/react-router";
import {isAuthenticated} from "../../../../utils/auth.ts";
import Layout from "../../../../components/Layouts/Layout.tsx";
import ManageNoteTypesContent from "../../../../components/Settings/ManageNoteTypesContent.tsx";

export const Route = createFileRoute('/settings/notes/manage/')({
  beforeLoad: async () => {
    if (!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <ManageNoteTypesContent />
    </Layout>
  );
}
